<template>
    <div>
        <div class="grid-box-fc">
            <div class="sp-card">
                <div class="title">计件二维码</div>
                <div class="mainNumber">{{element.totalPieceNum}}</div>
                <div class="other">
                    <div>
                        <span class="key">总数</span>
                        <span class="value">{{element.unitPieceSum}}</span>
                    </div>
                </div>
                <img class="img" src="../../../assets/p1.png" />
            </div>
            <div class="sp-card">
                <div class="title">扫码记录</div>
                <div class="mainNumber">{{element.totalScanNum}}</div>
                <div class="other">
                    <div>
                        <span class="key">总数</span>
                        <span class="value">{{element.unitScanNum}}</span>
                    </div>
                    <div>
                        <span class="key">金额</span>
                        <span class="value">{{element.sumPrice1}}</span>
                    </div>
                </div>
                <img class="img" src="../../../assets/p1.png" />
            </div>
            <div class="sp-card">
                <div id="piece1" style="width:100%;height:100%"></div>
            </div>
        </div>
        <div class="sp-card">
            <!-- <template #header>
                <div style="display:flex;justify-content: space-between;">
                    <div style="display:flex;">
                        <div class="cl"></div>
                        <span class="headtitle">生产进度</span>
                    </div>
                </div>
            </template> -->
            <div style="width:100%;height:240px;">
                <el-table :data="workingRecord" max-height="240" border>
                    <el-table-column label="产品" width="190">
                        <template slot-scope="{row}">
                            <div style="width:180px">{{"["+row.pnumber+"]"+row.pname}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="双数" prop="totalUnit" width="110"></el-table-column>
                    <el-table-column label="流程">
                        <template slot-scope="{row}">
                            <div>
                                <el-tag v-for="(item,index) in row.process" :key="index" effect="plain">{{item.name+"["+item.per+"]"}}</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="进度" width="80">
                        <template slot-scope="{row}">
                            <el-tag effect="dark" type="success">{{row.per}}</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- <div style="height:10px"></div>
        <div class="sp-card">
            员工计件统计
            <div style="width:100%;height:240px;">
                <el-table :data="pieceList" max-height="240">
                    <el-table-column label="员工编号" prop="enumber"></el-table-column>
                    <el-table-column label="员工名称" prop="ename"></el-table-column>
                    <el-table-column label="工序" prop="prname"></el-table-column>
                    <el-table-column label="商品编号" prop="pnumber"></el-table-column>
                    <el-table-column label="商品名称" prop="pname"></el-table-column>
                    <el-table-column label="双数" prop="unit"></el-table-column>
                    <el-table-column label="合格数" prop="check"></el-table-column>
                    <el-table-column label="合格率" prop="checkRate">
                        <template slot-scope="{row}">
                            <span>{{((row.check / row.unit).toFixed(4) * 100) + '%'}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div> -->
        <div style="height:10px"></div>
        <div class="sp-card">
            <div id="piece2" style="width:100%;height:360px;">
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    props:{
        filterbox:{
            type:Object,
            default:()=>{
                return {};
            }
        }
    },
    data(){
        return{
            element:{
                totalPieceNum:0,
                unitPieceSum:0,
                totalScanNum:0,
                unitScanNum:0,
                sumFailUnit:0,
                sumPrice1:0,
            },
            workingRecord:[],
            // pieceList:[],
            chartList:[null,null],
            isShowPage:false,
            myChart1:null,
            myChart2:null,
        }
    },
    methods:{
        setResize(){
            this.chartList.forEach(e=>{
                if(e){ e.resize(); }
            })
        },
        init:function(){
            this.isShowPage = true;
            this.getInfo();
        },
        close:function(){
            this.chartList.forEach(e=>{
                if(e&&(!e.isDisposed)){
                    e.dispose();
                }
            })
            this.isShowPage = false;
        },
        getMyChart:function(key){
            let myChart = this.chartList[key];
            if(!myChart){
                if(this.isShowPage){
                    myChart = echarts.init(document.getElementById('piece'+(key+1)));
                    this.chartList[key] = myChart;
                }
            }else{
                myChart.clear();
            }
            return myChart;
        },
        getInfo:function(){
            let obj = {};
            if(this.filterbox.time&&this.filterbox.time.length==2){
                obj.start = this.filterbox.time[0];
                obj.end = this.filterbox.time[1];
            }
            this.$api.listQrCode({page:1,limit:10,...obj}).then(res=>{
                this.element.unitPieceSum = res.data.data.unitSum;
                this.element.totalPieceNum = res.data.data.total;
            })
            this.$api.listQrCodeScanRecord({page:1,limit:10,...obj}).then(res=>{
                this.element.totalScanNum = res.data.data.total;
                this.element.unitScanNum = res.data.data.sumUnit;
                this.element.sumPrice1 = res.data.data.sumPrice1;
                this.element.sumFailUnit = res.data.data.sumFailUnit;
                let rightNum = this.element.unitScanNum-this.element.sumFailUnit;
                let temp = 0;
                if(this.element.unitScanNum>0){
                    temp = Number.parseFloat((rightNum*100/this.element.unitScanNum).toFixed(2));
                }
                let arr = [];
                arr.push({
                    name:'合格数',
                    value:rightNum,
                })
                arr.push({
                    name:'废品数',
                    value:this.element.sumFailUnit,
                })
                let myChart = this.getMyChart(0);
                if(myChart){
                    let option = {
                        title:{
                            text:'计件合格率',
                            subtext:temp+'%',
                            left:'left',
                        },
                        color:[
                            '#2EC7C9',
                            '#D87A80',
                        ],
                        tooltip: {
                            trigger: "item",
                        },
                        legend: {
                            orient: 'vertical',
                            left:'left',
                            bottom:'10px',
                        },
                        series: [
                            {
                                type: 'pie',
                                radius: ['40%', '70%'],
                                avoidLabelOverlap: false,
                                emphasis: {
                                    itemStyle: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                },
                                labelLine: {
                                    show: false
                                },
                                label: {
                                    show: false,
                                    position: 'center'
                                },
                                left: '40%',
                                data: arr,
                            }
                        ]
                    };
                    myChart.setOption(option);
                }
            })
            this.$api.panelData().then(res=>{
                if(res.data.code==1){
                    let data = res.data.data;
                    this.workingRecord = data.workingRecord;
                }
            })
            // let today = this.$common.dayformat(new Date());
            // let t = new Date().getTime() + (1000 * 3600 * 24);
            // let end = this.$common.dayformat(new Date(t));
            // this.$api.getQualified({page:1,limit:-1,start:today,end:end}).then(res=>{
            //     this.pieceList = res.data.data.data;
            // })
            this.$api.listQrCodeStaticis({page:1,limit:-1,groupBySpec:0,...obj}).then(res=>{
                let dd = res.data.data.data;
                let nameList = [];
                let itemList = [];
                dd.forEach(e=>{
                    let index = nameList.indexOf(e.pname);
                    if(index>=0){
                        let item = itemList[index];
                        item.completed+=e.completed;
                        item.doing+=e.doing;
                        item.noscaned+=e.noscaned;
                    }else{
                        let item = {
                            name:e.pname,
                            completed:e.completed,
                            doing:e.doing,
                            noscaned:e.noscaned,
                        }
                        itemList.push(item);
                        nameList.push(e.pname);
                    }
                })
                let myChart = this.getMyChart(1);
                if(myChart){
                    let option = {
                        legend: {},
                        title:{
                            text:'计件码统计',
                            left:'left',
                        },
                        color:[
                            '#dd524d',
                            '#007aff',
                            '#4cd964',
                        ],
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        grid: {
                            top:'20%',
                            left: '3%',
                            right: '4%',
                            bottom: '12%',
                            containLabel: true
                        },
                        xAxis: { type: 'category',data:itemList.map(e=>e.name) },
                        yAxis: {
                            type: 'value',
                            splitNumber:5,
                            // name: '单位:（双）',
                        },
                        dataZoom: [
                            {
                                type: 'slider',
                                show: true,
                                xAxisIndex: [0],
                                start: 0,
                                end: 100,
                            },
                        ],
                        series: [
                            { type: 'bar',name:'未开始',data:itemList.map(e=>e.noscaned) },
                            { type: 'bar',name:'生产中',data:itemList.map(e=>e.doing) },
                            { type: 'bar',name:'已完成',data:itemList.map(e=>e.completed) },
                        ]
                    };
                    myChart.setOption(option);
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.grid-box-fc{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px;
    padding-bottom: 10px;
}
</style>